import { Button } from "@moneyforward/mfx_biz_react_components";

type Props = {
  onClick: () => void;
  loading: boolean;
};

export const ChangeToAdminButton = ({ onClick, loading }: Props) => {
  return (
    <Button
      type="button"
      variant="secondary"
      onClick={onClick}
      disabled={loading}
    >
      管理者へ変更
    </Button>
  );
};
